import { Block } from "@/components/Block";
import { CopyIcon } from "@/components/CopyIcon";
import {
  Header,
  HeaderActionBack,
  HeaderActionCustomerService,
} from "@/components/Header";
import { Icon } from "@/components/Icon";
import { Layout } from "@/components/Layout";
import { PaymentIcons } from "@/components/PaymentIcons";
import { PaymentInfo } from "@/components/PaymentInfo";
import {
  PaymentLabelTemplate,
  PaymentOptions,
} from "@/components/PaymentSelector";
import { TradeBoard } from "@/components/TradeBoard";
import { TransactionStrStatusOnStep } from "@/components/TradeSteps";
import { OrderStatus, OrderType, Payments } from "@/constants";
import { cn } from "@/libs";
import { usePaymentsStore } from "@/stores/payments";
import tools, {
  amountFormat,
  dateFormat,
  parsePayments,
  toMoney,
} from "@/utils/tool";
import { Button, List, Selector } from "antd-mobile";
import { useEffect, useMemo, useState } from "react";
import { BoardProps } from "../buy_trading";
import styles from "./index.module.scss";
import "./index.scss";
import { SellingOrderStatus, useSetup } from "./logic";
import { ErType } from "@/constants/order/key";
import { useCryptoPayments } from "@/stores/CryptoTradingStore";
import { TRANSACTING_ORDER_STATUS, TRANSACTING_ORDER_TYPE, transactingOrderStatus } from "@/commons/models/order/status";

export const PageSelling = () => {
  const logic = useSetup();
  const {isMerchant,isProfession} = useCryptoPayments();
  const [payment, setPayment] = useState<any>();
  // 格式化后的支付方式列表
  const [formatPayments] = usePaymentsStore((state) => [
    state.formatPayments,
    state.payments,
  ]);
  //如果订单信息带支付方式
  useEffect(() => {
    if(logic.state.order && !payment){
      let valids = parsePayments(logic.state.order.paymentType).sort(); 
      if( isProfession ){//超级商家 单个选择支付方式
        valids=[logic.state.order.paymentType];
      }
      console.log('valids1111==',valids);
      setPayment(valids[0])
    }
  }, [logic.state.order, payment,isProfession])

  if (!logic.state.order) return <></>;

  let valids = parsePayments(logic.state.order.paymentType); // 转换为数字
  console.log('logic.state.order.paymentType==',logic.state.order.paymentType);
  console.log('valids==',valids);
  if( isProfession ){//超级商家 单个选择支付方式
    valids=[logic.state.order.paymentType];
  }
  const validsMap: Record<Payments, Payments> = valids.reduce(
    (p, c) => ({ [c]: c, ...p }),
    {}
  ) as Record<Payments, Payments>;
  // 买单时过滤掉无效的支付渠道，由于买家卖家的支付方式为多对多所以需要过滤无效值
  console.log('PaymentOptions==',PaymentOptions);
  console.log('validsMap==',validsMap);
  const _options = PaymentOptions.map((item) => {
    // console.log(item, 'options')
    const _item = Object.assign({}, item, { description: "" });
    const _payment = formatPayments[_item.value!];
    const _valid = validsMap[_item.value!];
    if(isMerchant && item.value === Payments.DIGITAL_RMB){
      _item.disabled = true;
    }
    if (tools.isUndefined(_payment) || tools.isUndefined(_valid)) {
      _item.disabled = true;
    }
    _item.label = <PaymentLabelTemplate name={item.label} icon={item.value as Payments}/>;
    return _item;
  }).filter(item => !item.disabled);
  console.log('_options==',_options);
  console.log('payment==',payment);
  console.log('logic.state.payment==',logic.state.payment);
  const filteredPayments = payment ? logic.state.payment.filter(
        (item) => item.type === payment 
      ) :[] 
      console.log('filteredPayments==',filteredPayments);

  return (
    <Layout
      scrollable
      backgroundImage={false}
      header={
        <Header
          title="我的挂单"
          leftActions={<HeaderActionBack />}
          rightActions={<HeaderActionCustomerService />}
        />
      }
    >
      <Board
        type={logic.state.order.isSplit}
        state={logic.state.status as SellingOrderStatus}
        orderDurations={logic.orderDurations}
      >
        {
        logic.state.status === SellingOrderStatus.SALE_OUT ||
        logic.state.status === SellingOrderStatus.HANGING ||
        logic.state.status === SellingOrderStatus.CANCELED_SELLING ? (
          <>
            <div className={styles.validAmount}>售卖数量</div>
            <div className={styles.amount}>
              <span>{amountFormat(logic.state.order.validAmount)}</span>
              <Icon name={"vcoin"} className={styles.amountIcon} />
            </div>
          </>
        ) : (
          <div className={styles.boardContentOrderNumber}>
            订单编号：{logic.state.order.pendingOrderNo}
            <CopyIcon text={logic.state.order.pendingOrderNo} />
          </div>
        )}
      </Board>

      {
      // logic.state.status === SellingOrderStatus.SALE_OUT ||
      logic.state.status === SellingOrderStatus.HANGING ||
      logic.state.status === SellingOrderStatus.CANCELED_SELLING ? (
        <>
          <Block topline title="订单详情">
            <div className={styles.formRow}>
              <div className={styles.formLabel}>创建时间</div>
              <div className={styles.formValue}>
                {dateFormat(logic.state.order.createTime, "Y/M/D h:m:s")}
              </div>
            </div>
            <div className={styles.formRow}>
              <div className={styles.formLabel}>收款方式</div>
              <div className={styles.paymentOptions}>
                <Selector
                  columns={4}
                  value={[payment]}
                  options={_options}
                  onChange={(keys) => {
                    setPayment(keys[0] || _options[0].value);
                  }}
                />
              </div>
            </div>
            <div className={styles.formRow}>
              <div className={styles.formLabel}>挂单编号</div>
              <div className={styles.formValue}>
                {logic.state.order.pendingOrderNo}
              </div>
              <CopyIcon text={logic.state.order.pendingOrderNo} />
            </div>
          </Block>
          <Block topline title="收款信息">
            <PaymentInfo
              payment={payment as Payments}
              info={filteredPayments[0]?.info}
              show={true}
            />
          </Block>
        </>
      ) : (
        <>
          <Block
            topline
            title={
              <div className={styles.blockTitle}>
                出售数量
                <div className={styles.vcoinNumber}>
                  <span>{toMoney(logic.state.order.validAmount)}</span>
                  <Icon
                    className={styles.vcoin}
                    name="vcoin"
                    size={["28px", "14px"]}
                  />
                </div>
              </div>
            }
          />
          <Block topline title="交易订单">
            <List
              className={styles.tableList}
              header={
                <div className={styles.tableTitle}>
                  <div className={styles.tableHeaderColTime}>发起时间</div>
                  <div className={styles.tableHeaderColAmount}>
                    购买数量
                    <span>V币</span>
                  </div>
                  <div className={styles.tableHeaderColPayment}>交易方式</div>
                  <div className={styles.tableHeaderColStatus}>状态</div>
                </div>
              }
            >
              {logic.books.data?.list.map((item) => {

                return (
                  <List.Item
                    className={styles.tableListItem}
                    onClick={() =>
                      logic.navigate(`/sell_trading/${item.orderId}?m=${item.sellerType === ErType.Business ? 1:0}`)
                    }
                    key={item.orderId}
                  >
                    <div className={styles.tableRow}>
                      <div className={styles.tableColTime}>
                        {dateFormat(item.createTime, "M/D h:m:s")}
                      </div>
                      <div className={styles.tableColAmount}>
                        {toMoney(item.amount)}
                      </div>
                      <div className={styles.tableColPayment}>
                        <PaymentIcons payments={item.paymentType} />
                      </div>
                      <div
                        className={cn(
                          styles.tableColStatus,
                          `order-status-${item.status}`
                        )}
                      >
                        {transactingOrderStatus(item.status as TRANSACTING_ORDER_STATUS, TRANSACTING_ORDER_TYPE.SELLER)}
                      </div>
                    </div>
                  </List.Item>
                );
              })}
            </List>
          </Block>
        </>
      )}

      <div className={styles.options}>
        {logic.state.status === SellingOrderStatus.HANGING && (
          <Button
            className={styles.cancelSellingBtn}
            onClick={logic.cancel.run}
            loading={logic.cancel.loading}
          >
            取消挂单
          </Button>
        )}
      </div>
    </Layout>
  );
};

/**
 * 订单的状态面板
 * @param param0
 * @returns
 */
const Board = ({
  children,
  state,
  type,
  orderDurations,
}: BoardProps<SellingOrderStatus> & { type: OrderType }) => {
  let text = null;

  switch (state) {
    case SellingOrderStatus.HANGING:
      text = (
        <div>
          <div className={styles.boardBgTitle}>挂单中...</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case SellingOrderStatus.SALE_OUT:
      text = (
        <div>
          <div className={styles.boardBgTitle}>已售罄</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case SellingOrderStatus.CANCELED_SELLING:
      text = (
        <div>
          <div className={styles.boardBgTitle}>取消挂单</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case SellingOrderStatus.BUYER_REQUEST:
      text = (
        <div>
          <div className={styles.boardBgTitle}>买家发起交易</div>
          <div className={styles.boardBgDesc}>
            <span className={styles.boardBgDescHighlight}>
              {orderDurations.waitingSellerConfirmDelayTime}
            </span>{" "}
            内未操作系统
            <br />
            将默认卖家取消交易
          </div>
        </div>
      );
      break;
    default:
      text = <div>状态错误:{state}</div>;
  }
  return (
    <TradeBoard
      className={styles.board}
      contentClassName={styles.boardContent}
      backgroundClassName={cn("selling-trade-board-bg", state)}
      background={
        <>
          <div className={styles.content}>
            <div className={cn("selling-trade-board-status", state)}></div>
            {text}
            <div
              className={cn(
                "selling-order-type",
                type === OrderType.SEPARABLY ? "separably" : "inseparably"
              )}
            >
              {type === OrderType.SEPARABLY ? "可拆分" : "不可拆分"}
            </div>
          </div>
        </>
      }
    >
      {children}
    </TradeBoard>
  );
};
